import Layout from "@/components/feature/Layout";
import SectionHeading from "@/components/base/SectionHeading";
import usePageMeta from "@/hooks/usePageMeta";
import { faqs } from "@/mocks/events";
import Hero from "./components/Hero";
import FeaturedEvents from "./components/FeaturedEvents";
import EventGrid from "./components/EventGrid";
import LiveComments from "./components/LiveComments";
import CategorySection from "./components/CategorySection";
import FaqSection from "./components/FaqSection";
import CtaBand from "./components/CtaBand";

export default function Home() {
  usePageMeta({
    title: "瓜田热评 · 热门吃瓜评论区_网友热评与高赞神回复围观现场",
    description:
      "瓜田热评聚合热门吃瓜事件现场，精选热门吃瓜评论区的网友热评与高赞神回复。看事件、看评论、看态度，感受最热闹的吃瓜现场，发现最有意思的网友观点。",
    keywords: "热门吃瓜,热门吃瓜评论区,热门吃瓜网友热评,热门吃瓜高赞评论,热门吃瓜神回复,吃瓜群",
    path: "/",
    jsonLd: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebSite",
          name: "瓜田热评",
          url: "/",
          description: "聚合热门吃瓜事件、网友热评与高赞神回复的围观现场内容平台",
          inLanguage: "zh-CN",
          potentialAction: {
            "@type": "SearchAction",
            target: "/events?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        },
        {
          "@type": "Organization",
          name: "瓜田热评",
          url: "/",
          slogan: "不只看热闹，更看神评论",
          email: "hello@guatian-hotcomment.cc",
        },
        {
          "@type": "FAQPage",
          mainEntity: faqs.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        },
      ],
    },
  });

  return (
    <Layout>
      <Hero />

      <section className="w-full px-4 py-12 md:px-8 md:py-16">
        <SectionHeading
          eyebrow="正在围观"
          title="今日瓜田头条"
          desc="热度最高、评论区最有看点的事件都在这里，点进去就能看到网友的犀利解读。"
          actionText="查看更多事件"
          actionTo="/events"
        />
        <FeaturedEvents />
      </section>

      <section className="w-full border-y border-background-200 bg-background-100 px-4 py-12 md:px-8 md:py-16">
        <SectionHeading
          eyebrow="瓜田广场"
          title="这些瓜，评论区比正文还精彩"
          desc="按分类快速找到你感兴趣的现场，每个事件都附有整理好的高赞热评。"
        />
        <EventGrid />
      </section>

      <section className="w-full px-4 py-12 md:px-8 md:py-16">
        <SectionHeading
          eyebrow="围观现场"
          title="神评精选 · 一句话说到心坎里"
          desc="从评论区里挑出来的高赞发言，有的犀利，有的温柔，有的让人笑到拍桌子。"
          actionText="查看完整神评榜"
          actionTo="/comments"
        />
        <LiveComments />
      </section>

      <section className="w-full border-y border-background-200 bg-background-100 px-4 py-12 md:px-8 md:py-16">
        <SectionHeading
          eyebrow="栏目导航"
          title="按你喜欢的口味逛瓜田"
          desc="娱乐圈的名场面、街头巷尾的暖心事、日常生活的烟火气，各有各的精彩。"
        />
        <CategorySection />
      </section>

      <section className="w-full px-4 py-12 md:px-8 md:py-16">
        <FaqSection />
      </section>

      <section className="w-full px-4 pb-4 md:px-8">
        <CtaBand />
      </section>
    </Layout>
  );
}